import { Calendar } from "@fullcalendar/core";
import jaLocale from "@fullcalendar/core/locales/ja";
import dayGridPlugin from "@fullcalendar/daygrid";

const hasDomAccess =
  typeof window !== "undefined" && typeof document !== "undefined";

const initOpenCampusCalendar = () => {
  if (!hasDomAccess) return;

  const calendarEl = document.querySelector(".js-open-campus-calendar");
  const calendarData = window.EiseiOpenCampus?.events || [];

  if (!calendarEl || calendarData.length === 0) return;

  const calendar = new Calendar(calendarEl, {
    plugins: [dayGridPlugin],
    initialView: "dayGridMonth",
    height: "auto",
    locales: [jaLocale],
    locale: "ja",
    firstDay: 0,
    showNonCurrentDates: false,
    fixedWeekCount: false,
    headerToolbar: {
      left: "prev",
      center: "title",
      right: "next",
    },
    buttonText: {
      prev: "前の月",
      next: "次の月",
    },
    dayHeaders: false,
    dayCellContent(info) {
      const numericText = info.dayNumberText.replace(/[^0-9]/g, "");
      return {
        html: `<span class="fc-daygrid-day-number">${numericText}</span>`,
      };
    },
    events: calendarData,
    eventContent(info) {
      const categoryLabel = info.event.extendedProps.categoryLabel || "";

      const pill = document.createElement("span");
      pill.classList.add("fc-event-pill");

      const colorClass = info.event.extendedProps.colorClass;
      if (colorClass) {
        colorClass.split(" ").forEach((cls) => {
          if (cls) pill.classList.add(cls);
        });
      }

      pill.textContent = categoryLabel || info.event.title;

      return { domNodes: [pill] };
    },
    eventClick(info) {
      if (info.event.url) {
        info.jsEvent.preventDefault();
        window.location.href = info.event.url;
      }
    },
  });

  calendar.render();

  // 凡例（レジェンド）を .fc-header-toolbar と .fc-view-harness の間に挿入
  const legendData = window.EiseiOpenCampus?.legends || [];
  const headerToolbar = calendarEl.querySelector(".fc-header-toolbar");
  if (legendData.length > 0 && headerToolbar) {
    const legendUl = document.createElement("ul");
    legendUl.classList.add("open-campus-calendar__legend");

    legendData.forEach((item) => {
      const li = document.createElement("li");
      li.classList.add("open-campus-calendar__legend-item");
      if (item.slug) {
        li.classList.add(`--${item.slug}`);
      }
      li.textContent = item.name;
      legendUl.appendChild(li);
    });

    headerToolbar.insertAdjacentElement("afterend", legendUl);
  }
};

export { initOpenCampusCalendar as default };
